'use client';

import { getFragmentData } from '@/__generated__';
import { ArticleCardFragment } from '@/__generated__/graphql';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import { parseUri } from '@liquorice/utils';
import Card from '../Card';
import { OverrideCardProps } from '../EntryCards';
import Box from '../ui/Box';
import Divider from '../ui/Divider';

export const ArticleCard = ({
  data,
  overrides,
}: {
  data?: ArticleCardFragment;
  overrides?: OverrideCardProps;
}) => {
  if (!data) return null;

  const { entryImage, entryTitle, entrySummary, ...base } = data;
  const { heading: maybeTitle, image: maybeImage, content: maybeContent } = overrides ?? {};

  const { uri, postDate } = getFragmentData(ENTRY_BASE_FRAGMENT, base);
  const href = parseUri(uri);

  return (
    <Card
      colorSet="white"
      paper
      fullHeight
      elevation={false}
      item={{
        href,
        image: maybeImage ?? entryImage,
        title: maybeTitle ?? entryTitle,
        meta: postDate,
        description: maybeContent ?? entrySummary,
      }}>
      <Box cx={{ mB: '2xs' }}>
        <Card.Image ratio="landscape" />
      </Box>
      <Card.Body cx={{ mB: 'lg' }}>
        <Card.Title variant="medium" weight="semibold" />
        <Card.Description variant="small" color="black" enableTruncate />
      </Card.Body>
      <Card.Foot cx={{ display: 'flex', justifyContent: 'between' }}>
        <Card.Meta cx={{ fontSize: 'tiny' }} uppercase />
        <Card.Cta
          variant="text"
          weight="semibold"
          uppercase
          EndIconProps={{ name: 'chevronRight', cx: { fontSize: 'h5' } }}
          cx={{ fontSize: 'medium', mB: 'xs' }}
        />
      </Card.Foot>
      <Divider direction="horizontal" />
    </Card>
  );
};
